import React from 'react';
import styled, { keyframes } from 'styled-components';
import { assets } from '../../../assets';
import { MattRow } from '../../../components/containers/containers';
import { HorizontalSeparator } from '../../../components/ui-utils/separators';
import { formatDateTime } from '../../../helpers/date-formatters';
import { Notification } from '../../../logic/graphql/types/types';
import { getDirectionIcon, getDirectionText } from '../../utils/direction-utils';
import { FormattedMessage, useIntl } from 'react-intl';

const growAnimation = keyframes`
  from {
    max-height: 0px;
  }

  to {
    max-height: 300px;
  }
`;

const borderAnimation = keyframes`
  0% {
    border: 1px solid var(--primary-text-color);
  }

  80% {
    border: 1px solid var(--primary-text-color);
  }

  100% {
    border: 1px solid var(--matt-bg-color);
  }
`;

const newLabelAnimation = keyframes`
0% {
  opacity: 1;
}

80% {
  opacity: 1;
}

100% {
  opacity: 0;
}
`;

const NotificationCardWrapper = styled(MattRow).attrs(() => ({}))<{
  animated: boolean;
}>`
  margin-bottom: 20px;
  padding: 10px 14px;
  width: 200px;
  border: 1px solid var(--matt-bg-color);
  animation: ${growAnimation}
      ${(props) => (props.animated ? `1s ease-out 0s 1` : '0s ease-out 0s 1')},
    ${borderAnimation} ${(props) => (props.animated ? `4s linear 0s 1` : '0s linear 0s 1')};
  overflow: hidden;
  &:last-of-type {
    margin-bottom: 0px;
  }
`;

const ClockIcon = styled.img`
  width: 15px;
  height: 15px;
  margin-right: 4px;
`;

const DirectionIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 4px;
`;

const NewLabel = styled.span.attrs(() => ({}))<{
  animated: boolean;
}>`
  background-color: var(--success-color);
  border-radius: 2px;
  padding: 2px 4px;
  opacity: 0;
  animation: ${newLabelAnimation}
    ${(props) => (props.animated ? `4s linear 0s 1` : '0s linear 0s 1')};
`;

const NotificationListItem = (props: {
  notification: Notification;
  new?: boolean;
  style?: React.CSSProperties | undefined;
}): JSX.Element => {
  const intl = useIntl();
  return (
    <NotificationCardWrapper animated={!!props.new} style={props.style}>
      <div className="flex flex-row mb-1">
        <div className="flex flex-row items-center">
          <DirectionIcon src={getDirectionIcon(props.notification.direction)} />
          <span className="text-10">
            {intl.formatMessage({
              id: `notification.type.${getDirectionText(props.notification.direction)}`,
            })}
          </span>
        </div>
      </div>
      <HorizontalSeparator className="mb-1" />

      <p className="text-10 mb-2">{props.notification.text}</p>
      <HorizontalSeparator className="mb-2" />

      <div className="flex flex-row justify-between">
        <div className="flex flex-row items-center">
          <ClockIcon src={assets.icons.clock} />
          <span className="text-8 text-lightgray">{formatDateTime(props.notification.time)}</span>
        </div>
        {props.new && (
          <NewLabel className="text-8 mr-0px" animated={!!props.new}>
            <b>
              <FormattedMessage id={'notification.newBadge'} />
            </b>
          </NewLabel>
        )}
      </div>
    </NotificationCardWrapper>
  );
};

export default NotificationListItem;
